<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : replacementBill.pkid > 0 ? '编辑' : '新建'"
      width="1200px"
      height="100vh"
      top="10px"
      @close="dialogClose">
    <el-tabs v-model="defaultTabName" height="70vh">
      <el-tab-pane name="p1" label="基本信息">
        <el-form
            ref="form"
            v-loading="contentLoading"
            :disabled="disabled"
            :model="replacementBill"
            :rules="ruleValidate"
            class="form"
            label-width="100px">
          <!--          <div class="editTitle">基本信息</div>-->
          <el-row>
            <el-col v-if="replacementBill.pkid > 0" :span="12">
              <el-form-item label="编号" prop="billNo">
                <el-input v-model="replacementBill.billNo" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司" prop="factoryNo">
                <el-input v-model="replacementBill.factoryNo"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产地" prop="problemAddress">
                <el-select v-model="replacementBill.problemAddress">
                  <el-option value="上海" label="上海"/>
                  <el-option value="江苏" label="江苏"/>
                  <el-option value="采购" label="采购"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户名称" prop="customerName">
                <el-input v-model="replacementBill.customerName" readonly placeholder="请选择客户">
                  <el-button
                      slot="append"
                      icon="el-icon-search"
                      :disabled="replacementBill.pkid > 0"
                      @click="$refs.selectCustomerName.open()"/>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="销售订单编号" prop="salesOrderNo">
                <el-input v-model="replacementBill.salesOrderNo"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="note">
                <el-input v-model="replacementBill.note" type="textarea" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="editTitle" style="margin-top: 10px">明细</div>
          <div style="text-align: right;">
            <el-button
                v-if="!disabled"
                type="primary"
                style="margin-bottom: 10px;margin-right: 10px;"
                @click="$refs.selectMaterial.open('已上架')">
              添加
            </el-button>
          </div>
          <el-table
              class="tableBox"
              :data="replacementBill.details"
              border
              stripe
              height="40vh">
            <el-table-column prop="materialNo" align="left" label="物料编号" width="160"/>
            <el-table-column prop="materialName" align="left" label="物料名称" width="120"/>
            <el-table-column prop="specification" align="center" label="规格型号" width="200"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity"/>
              </template>
            </el-table-column>
            <el-table-column prop="deliveryDate" label="出货日期" align="center" width="160">
              <template slot-scope="scope">
                <el-date-picker
                    v-model="scope.row.deliveryDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择日期"/>
              </template>
            </el-table-column>
            <el-table-column prop="badQuantity" align="center" label="异常数量" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.badQuantity"/>
              </template>
            </el-table-column>
            <el-table-column prop="materialType" align="center" label="产品类型" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.materialType"/>
              </template>
            </el-table-column>
            <el-table-column prop="returnProd" align="center" label="是否退货" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.returnProd"/>
              </template>
            </el-table-column>
            <el-table-column prop="returnDate" label="预计退回时间" align="center" width="160">
              <template slot-scope="scope">
                <el-date-picker
                    v-model="scope.row.returnDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择日期"/>
              </template>
            </el-table-column>
            <el-table-column prop="problemDesc" align="center" label="备注" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.problemDesc" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="80">
              <template v-slot="scope">
                <el-button type="danger" @click="deleteRow(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--      <sales-order-detail-select ref="orderDetailSelect" @select="detailSelect"/>-->
          <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
          <material-select ref="selectMaterial" @select="selectMaterial"/>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="p2" label="附件">
        <el-form
            ref="form"
            :model="replacementBill"
            class="form"
            label-width="80px">
          <el-row>
            <!--        <el-divider/>-->
            <upload-file
                ref="upload"
                :disabled="disabled"
                :show-file-list="false"
                :auth-index="authIndex"
                style="text-align: right;margin-top: 2px;"
                @upload-success="uploadSuccess"/>
            <el-table :data="replacementBill.attachments" height="60vh" border>
              <el-table-column prop="fileName" align="left" label="附件" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.fileName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="creatorName" align="left" label="创建人" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.creatorName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" align="left" label="创建时间" width="140">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
                <template slot-scope="scope">
                  <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
                  <el-button type="danger" @click="replacementBill.attachments.splice(scope.$index, 1)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="p3" label="解决方案" v-if="showSolution">
        <el-form class="form" label-width="100px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="临时解决方案">
                <el-input v-model="replacementBill.problemSolution" type="textarea" autosize readonly/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="库存盘查">
                <el-input v-model="replacementBill.productInformation" type="textarea" autosize readonly/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="责任部门">
                <el-input v-model="replacementBill.improvementDepartment" readonly/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="最终责任判断">
                <el-input v-model="replacementBill.finalConclusion" type="textarea" autosize readonly/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="填写损失">
                <el-input v-model="replacementBill.comment" type="textarea" autosize readonly/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-table :data="listSolution1_0" style="margin-top: 5px;">
            <el-table-column prop="solutionType" label="产品状态分布(围堵措施)"  align="center" width="160"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity" readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="solution" align="center" label="处理方案">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.feedBack" readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solutionHandler" readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件" width="200">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
                <el-Button type="danger" style="margin-left: 2px;" @click="deleteFile1_0()" v-if="scope.row.fileName">
                  删除
                </el-Button>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160"/>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="listSolution2" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="根本原因分析">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件" width="300">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="listSolution3" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="listSolution4" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="永久纠正错误及执行">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件" width="300">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="listSolution5" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="预防再发生">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="listSolution6" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="文件">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="solutionHandler" align="center" label="负责人" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solutionHandler" readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" align="center" label="完成日期" width="150"/>
            <el-table-column prop="fileNo" align="center" label="文件编号" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fileNo" readonly/>
              </template>
            </el-table-column>
            <el-table-column prop="qmConfirm" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.qmConfirm" type="textarea" autosize readonly/>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit(0)">保存</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit(1)">保存并提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SalesOrderDetailSelect from "@/views/SalesManage/SalesOrder/SalesOrderDetailSelect";
import CustomerSelect from "@/views/information/Customer/CustomerSelect";
import MaterialSelect from "@/views/information/Material/MaterialSelect";
import UploadFile from "@/components/UploadFile";

export default {
  name: "ReplacementBillEdit",
  components: {
    SalesOrderDetailSelect,
    CustomerSelect,
    MaterialSelect,
    UploadFile,
  },
  data() {
    return {
      authIndex: 625,
      disabled: false,
      dialogVisible: false,
      submitLoading: false,
      contentLoading: false,
      index: 0,
      defaultTabName: "p1",
      showSolution: false,
      replacementBill: {
        pkid: 0,
        billNo: "",
        customerId: 0,
        customerName: "",
        salesOrderNo: "",
        problemAddress: "上海",
        factoryNo: "",
        status: "",
        statusName: "",
        creatorName: "",
        createTime: "",
        note: "",
        problemSolution: "",
        productInformation: "",
        finalConclusion: "",
        improvementDepartment: "",
        details: [],
        attachments: [],
        solutions: [],
      },
      listSolution1_0: [],
      listSolution1_1: [],
      listSolution1_2: [],
      listSolution1_3: [],
      listSolution1_4: [],
      listSolution2: [],
      listSolution3: [],
      listSolution4: [],
      listSolution5: [],
      listSolution6: [],
      solution1_0: {
        rowIndex: 1,
        solutionType: "在生产",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_1: {
        rowIndex: 2,
        solutionType: "库存",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_2: {
        rowIndex: 3,
        solutionType: "运输途中",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_3: {
        rowIndex: 4,
        solutionType: "已出货",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_4: {
        rowIndex: 5,
        solutionType: "受影响的其它材料",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution2: {
        rowIndex: 2,
        solutionType: "根本原因分析",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution3: {
        rowIndex: 3,
        solutionType: "指定临时对策",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution4: {
        rowIndex: 4,
        solutionType: "永久纠正错误及执行",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution5: {
        rowIndex: 5,
        solutionType: "预防再发生",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution6: {
        rowIndex: 6,
        solutionType: "涉及时，更新这些项目反映更改内容",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      ruleValidate: {
        customerName: {required: true, message: "请选择客户", trigger: "change"},
        problemAddress: {required: true, message: "请输入生产地", trigger: "blur"},
        salesOrderNo: {required: true, message: "请输入销售订单号", trigger: "blur"},
      },
    };
  },
  methods: {
    open(id, disabled) {
      this.dialogVisible = true;
      this.defaultTabName = "p1";
      this.showSolution = false;
      if (id) {
        this.replacementBill.pkid = id;
        this.getData();
      }
      if (disabled) {
        this.disabled = true;
      }
    },

    // 根据id查询详细信息
    getData() {
      this.contentLoading = true;
      this.listSolution1_0 = [];
      this.listSolution1_1 = [];
      this.listSolution1_2 = [];
      this.listSolution1_3 = [];
      this.listSolution1_4 = [];
      this.listSolution2 = [];
      this.listSolution3 = [];
      this.listSolution4 = [];
      this.listSolution5 = [];
      this.listSolution6 = [];
      this.listSolution1_0.push(this.solution1_0);
      this.listSolution1_1.push(this.solution1_1);
      this.listSolution1_2.push(this.solution1_2);
      this.listSolution1_3.push(this.solution1_3);
      this.listSolution1_4.push(this.solution1_4);
      this.listSolution2.push(this.solution2);
      this.listSolution3.push(this.solution3);
      this.listSolution4.push(this.solution4);
      this.listSolution5.push(this.solution5);
      this.listSolution6.push(this.solution6);
      this.$http
          .get("basic", `replacementBills/${this.replacementBill.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.replacementBill = Object.assign(this.replacementBill, resp.data);
              if (this.replacementBill.statusName == "通过") {
                this.showSolution = true;
              } else {
                this.showSolution = false;
              }
              if (this.replacementBill.solutions.length > 0) {
                this.updateSolution(this.listSolution1_0, this.replacementBill.solutions[0]);
                this.updateSolution(this.listSolution1_1, this.replacementBill.solutions[1]);
                this.updateSolution(this.listSolution1_2, this.replacementBill.solutions[2]);
                this.updateSolution(this.listSolution1_3, this.replacementBill.solutions[3]);
                this.updateSolution(this.listSolution1_4, this.replacementBill.solutions[4]);
                this.updateSolution(this.listSolution2, this.replacementBill.solutions[5]);
                this.updateSolution(this.listSolution3, this.replacementBill.solutions[6]);
                this.updateSolution(this.listSolution4, this.replacementBill.solutions[7]);
                this.updateSolution(this.listSolution5, this.replacementBill.solutions[8]);
                this.updateSolution(this.listSolution6, this.replacementBill.solutions[9]);

                this.listSolution1_0.push(this.listSolution1_1[0]);
                this.listSolution1_0.push(this.listSolution1_2[0]);
                this.listSolution1_0.push(this.listSolution1_3[0]);
                this.listSolution1_0.push(this.listSolution1_4[0]);
              }

              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
    },
    // 下载
    downLoad(row) {
      this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
        if (res.success) {
          window.open(res.data);
        }
      });
    },

    updateSolution(listSolution, solution) {
      listSolution.forEach((item) => {
        item.productStatus = solution.productStatus;
        item.quantity = solution.quantity;
        item.solution = solution.solution;
        item.feedBack = solution.feedBack;
        item.solutionHandler = solution.solutionHandler;
        item.completionTimePlan = solution.completionTimePlan;
        item.filePath = solution.filePath;
        item.fileName = solution.fileName;
        item.fileNo = solution.fileNo;
        item.qmConfirm = solution.qmConfirm;
        item.note = solution.note;
      });
    },

    // 添加物料
    selectMaterial(row) {
      this.replacementBill.details.push({
        pkid: 0,
        masterId: 0,
        materialId: row.materialID,
        materialName: row.materialName,
        materialNo: row.materialNO,
        specification: row.specification,
        deliveryType: "",
        deliveryAccount: "",
        quantity: 1,
        badQuantity: 1,
        unit: "",
      });
    },

    // 选择客户
    selectCustomerName(row) {
      this.replacementBill.customerId = row.customerID;
      this.replacementBill.customerName = row.customerName;
    },
    uploadSuccess(fileList) {
      if (fileList.length) {
        const params = {
          fileName: fileList[0].name,
          filePath: fileList[0].key,
        };
        this.replacementBill.attachments.push(params);
      }
    },
    setIndex(index) {
      this.index = index;
    },

    deleteRow(row, index) {
      this.replacementBill.details.splice(index, 1);
    },

    // 编辑、新建
    handleSubmit(isSave) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.replacementBill.details.length) {
            this.$confirm("请添加明细", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          this.submitLoading = true;
          this.$http
              .post("basic", `replacementBills/save/${isSave}`, this.replacementBill)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.replacementBill.pkid > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  if (isSave) {
                    //发送通知
                    this.$http.post("basic", "replacementBills/updateNotify/" + resp.data).catch(() => {
                    });
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
        }
      });
    },

    dialogClose() {
      this.dialogVisible = false;
      this.disabled = false;
      this.replacementBill = {};
      try {
        this.$reset("form");
      } catch (e) {
      }
    },

  },
};
</script>

<style lang="scss" scoped>

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
